module.exports = __webpack_public_path__ + "static/media/Team3.1332b965.jpg";